module.exports = __webpack_public_path__ + "static2023-4-17/img/answer-right_title.812be70c.png";